import React from 'react';
import propTypes from 'prop-types';

import ApplicationProtection from './ApplicationProtection';
import { getMessage } from 'util/locale';


const CropProtectionSelection = ({
  applicationType,
  cropProtections,
  onSelectApplicationType,
  onSetApplication,
  selectedProduct
}) => {
  return (
    <div className="crop-protection-selection">
      <div className="crop-protection-type-label">{getMessage('crop-application')}</div>
      {
        cropProtections.map(cp => (
          <ApplicationProtection
            chemType={cp.chemType}
            onSelectApplicationType={onSelectApplicationType}
            onSetApplication={onSetApplication}
            products={cp.products}
            selectedProduct={selectedProduct}
            toggled={applicationType === cp.chemType}
            key={selectedProduct.id}
          />)
        )
      }

    </div>
  );
};

CropProtectionSelection.propTypes = {
  applicationType: propTypes.string,
  cropProtections: propTypes.array,
  onSelectApplicationType: propTypes.func,
  onSetApplication: propTypes.func,
  selectedProduct: propTypes.object
};

export default CropProtectionSelection;
